import { KYMW6100Model } from '../kymw6100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWS画像指示一覧表を取得する
 *
 * @export getCwsUseImageInfoService
 * @class GetCwsUseImageInfoService
 * @extends {PlessJsonResponderSub}
 */
 @Injectable()
export class GetCwsUseImageInfoService extends PlessJsonResponderSub<any> {

  vo = {
    orderCode : '',
  };

  // 処理に使用するModel
  private model: KYMW6100Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCwsUseImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CwsUseImageInfo: {
          condition: {
            OrderCode: this.vo.orderCode
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCwsUseImageInfoService
   */
  execute(model: KYMW6100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCwsUseImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCwsUseImageInfoService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileName(data);
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
